// extracted by mini-css-extract-plugin
export var checkbox = "_57-0";
export var circle = "_57-3";
export var horizontalContainer = "_57-7";
export var sm = "_57-5";
export var switch0 = "_57-2";
export var switchDisabled = "_57-8";
export var switchEnabled = "_57-1";
export var textSwitchContainer = "_57-9";
export var textSwitchOption = "_57-a";
export var textSwitchOptionSelected = "_57-b";
export var verticalContainer = "_57-6";
export var xs = "_57-4";